import jQuery from 'jquery';
import axios from 'axios';
import {tabler, bootstrap} from "@tabler/core";
import moment from 'moment';


window.jQuery = window.$ = jQuery;
window.bootstrap = bootstrap;
window.tabler = tabler;
window.moment = moment;
